const initialState = { isOutdated: false };

export const VERSION_UPDATED = 'VERSION_UPDATED';

export const versionStatus = (state = initialState, action) => {
    switch (action.type) {
        case VERSION_UPDATED:
            return { ...state, isOutdated: true };
        default:
            return state;
    }
};
